import React, {useState, Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@mui/material/Button";
import {getPortfolio, isEmptyProfile} from "../store/actions";
import {Link} from "react-router-dom";
import {Container} from "@mui/material";
import Tinkoff_API from "./Tinkoff_API";
import Grid from '@mui/material/Grid';


export default function() {
    const dispatch = useDispatch();

    const handleExit = () => {
        dispatch(isEmptyProfile(true))
    };

    return(
    <Container maxWidth="sm" >
        <ButtonGroup sx={{ mr: 1, mt:2}} color="primary" fullWidth aria-label="outlined primary button group">
            <Button size="large" sx={{ height: 150 }} onClick={handleExit} to={"/portfolio"} component={Link}  variant="outlined" color="primary" >
                Добавить вручную
            </Button>
            <Button size="large" sx={{ height: 150 }} to={"/transactions"} component={Link}  variant="outlined" color="primary" >
                Импорт сделок
            </Button>
        </ButtonGroup>
    </Container>
)
}